document.addEventListener("DOMContentLoaded", function () {
  const splideElement = document.getElementById("splide-how-to");
  const initial_interval = parseInt(splideElement.dataset.initialInterval || "5");

  let globalMuteState = true;

  var splide = new Splide("#splide-how-to", {
    type: "loop",
    autoplay: true,
    resetProgress: false,
    perPage: 1,
    pauseOnHover: false,
    interval: initial_interval * 1000,
    arrows: true,
  });

  const playToggle = document.querySelector(".splide__toggle");
  const playIcon = document.querySelector(".splide__toggle__play");
  const pauseIcon = document.querySelector(".splide__toggle__pause");
  const soundToggle = document.querySelector(".splide__sound-toggle");
  const soundOnIcon = document.querySelector(".icon-sound-on");
  const soundOffIcon = document.querySelector(".icon-sound-off");

  function updatePlayPauseIcon() {
    const currentVideo = splide.Components.Slides.getAt(splide.index).slide.querySelector("video");
    if (currentVideo && currentVideo.paused) {
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
      playToggle.setAttribute("aria-label", "Reproduzir vídeo");
    } else if (currentVideo) {
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
      playToggle.setAttribute("aria-label", "Pausar vídeo");
    }
  }

  function updateSoundIcon() {
    const currentVideo = splide.Components.Slides.getAt(splide.index).slide.querySelector("video");
    if (currentVideo && currentVideo.muted) {
      soundOnIcon.style.display = "none";
      soundOffIcon.style.display = "block";
      soundToggle.setAttribute("aria-label", "Ativar som");
    } else if (currentVideo) {
      soundOnIcon.style.display = "block";
      soundOffIcon.style.display = "none";
      soundToggle.setAttribute("aria-label", "Desativar som");
    }
  }

  function updateAllIcons() {
    updatePlayPauseIcon();
    updateSoundIcon();
  }

  function adjustVideoContainer(video) {
    if (video && video.videoWidth && video.videoHeight) {
      const videoRatio = video.videoWidth / video.videoHeight;
      const container = video.closest(".how-to-use__slide-media");
      
      if (container) {
        const ratioPercent = (1 / videoRatio) * 100;
        
        container.style.setProperty("--ratio-percent", ratioPercent + "%", "important");
        container.style.setProperty("aspect-ratio", "auto", "important");
        container.style.setProperty("padding-bottom", "var(--ratio-percent)", "important");
        container.style.setProperty("height", "0", "important");
        container.style.setProperty("position", "relative", "important");
        
        video.style.setProperty("object-fit", "cover", "important");
        video.style.setProperty("width", "100%", "important");
        video.style.setProperty("height", "100%", "important");
        video.style.setProperty("position", "absolute", "important");
        video.style.setProperty("top", "0", "important");
        video.style.setProperty("left", "0", "important");
      }
    }
  }

  function goToNextSlide() {
    splide.go("+1");
  }

  function movePaginationIntoControls(paginationEl) {
    const controls = document.querySelector("#splide-how-to .how-to-use__video-controls");
    const pagination = paginationEl || document.querySelector("#splide-how-to .splide__pagination");
    if (controls && pagination) {
      controls.prepend(pagination);
      pagination.style.position = "static";
      pagination.style.left = "auto";
      pagination.style.bottom = "auto";
      pagination.style.transform = "none";
    }
  }

  splide.on("pagination:mounted", function (data) {
    movePaginationIntoControls(data.list);
  });

  splide.on("mounted", function () {
    const currentVideo = splide.Components.Slides.getAt(splide.index).slide.querySelector("video");
    if (currentVideo) {
      currentVideo.muted = globalMuteState;
      currentVideo.addEventListener("play", updatePlayPauseIcon);
      currentVideo.addEventListener("pause", updatePlayPauseIcon);
      currentVideo.addEventListener("volumechange", updateSoundIcon);
      currentVideo.addEventListener("ended", goToNextSlide);
      currentVideo.addEventListener("loadedmetadata", function () {
        adjustVideoContainer(currentVideo);
      });
      
      if (currentVideo.readyState >= 1) {
        adjustVideoContainer(currentVideo);
      }
      
      setTimeout(() => {
        adjustVideoContainer(currentVideo);
      }, 100);
      
      setTimeout(() => {
        adjustVideoContainer(currentVideo);
      }, 500);
      
      setTimeout(() => {
        currentVideo.play().catch(function (error) {
          console.log("Erro ao reproduzir primeiro vídeo:", error);
        });
      }, 300);
      updateAllIcons();
    }

    movePaginationIntoControls();
  });

  splide.on("moved", function (newIndex, prevIndex) {
    const prevVideo = splide.Components.Slides.getAt(prevIndex).slide.querySelector("video");
    if (prevVideo) {
      prevVideo.pause();
      prevVideo.muted = true;
      prevVideo.currentTime = 0;
      prevVideo.removeEventListener("play", updatePlayPauseIcon);
      prevVideo.removeEventListener("pause", updatePlayPauseIcon);
      prevVideo.removeEventListener("volumechange", updateSoundIcon);
      prevVideo.removeEventListener("ended", goToNextSlide);
    }

    const currentVideo = splide.Components.Slides.getAt(newIndex).slide.querySelector("video");
    if (currentVideo) {
      currentVideo.muted = globalMuteState;
      currentVideo.addEventListener("play", updatePlayPauseIcon);
      currentVideo.addEventListener("pause", updatePlayPauseIcon);
      currentVideo.addEventListener("volumechange", updateSoundIcon);
      currentVideo.addEventListener("ended", goToNextSlide);
      currentVideo.addEventListener("loadedmetadata", function () {
        adjustVideoContainer(currentVideo);
      });
      
      if (currentVideo.readyState >= 1) {
        adjustVideoContainer(currentVideo);
      }
      
      setTimeout(() => {
        adjustVideoContainer(currentVideo);
      }, 50);
      
      setTimeout(() => {
        adjustVideoContainer(currentVideo);
      }, 300);
      
      setTimeout(() => {
        currentVideo.play().catch(function (error) {
          console.log("Erro ao reproduzir vídeo:", error);
        });
      }, 200);
    }

    setTimeout(updateAllIcons, 100);
  });

  playToggle.addEventListener("click", function () {
    const currentVideo = splide.Components.Slides.getAt(splide.index).slide.querySelector("video");
    if (currentVideo) {
      currentVideo.paused ? currentVideo.play() : currentVideo.pause();
      updatePlayPauseIcon();
    }
  });

  soundToggle.addEventListener("click", function () {
    const currentVideo = splide.Components.Slides.getAt(splide.index).slide.querySelector("video");
    if (currentVideo) {
      currentVideo.muted = !currentVideo.muted;
      globalMuteState = currentVideo.muted;
      updateSoundIcon();

      currentVideo.removeEventListener("ended", goToNextSlide);
      currentVideo.addEventListener("ended", goToNextSlide);
    }
  });

  splide.mount();
});
